import { render, staticRenderFns } from "./Inventario-placeholder.vue?vue&type=template&id=1fb9bd74"
import script from "./Inventario-placeholder.vue?vue&type=script&lang=js"
export * from "./Inventario-placeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports